export default __webpack_public_path__ + "static/media/tutorial2-3.1b58dfb6.png";